// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//import 'lib-flexible'
//import Vant from 'vant';
//import 'vant/lib/index.css';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);
//Vue.use(Vant);
Vue.config.productionTip = false

let session = localStorage.getItem('session');

function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}


if(!session){
    session = uuid();
    localStorage.setItem('session',session);
}

import {
  Basic_SysInfo,
  Auth_IsLogin,
  IsWxBind,
  Auth_Wx
} from "@/api/api.js"
import querystring from 'querystring';

Basic_SysInfo({},function(res){
  document.title = res.model.app_title;
})


if(location.pathname.indexOf('/wechat/gift') != 0
  && location.pathname.indexOf('/syspay') != 0) {
  Auth_IsLogin({},function(res){
    if(res.code == 500){
      IsWxBind({},function(res){
        if(res.model){
          if(location.pathname != '/')
            location.href = '/';
        }
        else{        
          let options = querystring.parse(location.search.replace('?', ''));
          debugger;
          if(options.code && options.state){
            Auth_Wx({code:options.code,state:options.state},function(res){
              debugger;
              Auth_IsLogin({},function(res){
                debugger;
                if(res.code == 500){
                  if(location.pathname != '/')
                    location.href = '/';
                }
                else{
                  location.href = '/wechat/home';
                }
              });
            })
          }
          else{
            this.$confirm({
              title: '微信授权',
              okText: '授权',
              okType: 'danger',
              cancelText: '取消',
              content: h => <div style="color:red;">是否确认微信授权？</div>,
              onOk() {
                if(location.hostname == 'hy.xiaoqinhaishen.com')
                  location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe612280d6c8e07bc&redirect_uri=${window.encodeURIComponent(location.origin)}&response_type=code&scope=snsapi_userinfo&state=${uuid()}#wechat_redirect`
                else if(location.hostname == 'hy.shengongshiye.com')
                  location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8e0b328aebe6955a&redirect_uri=${window.encodeURIComponent(location.origin)}&response_type=code&scope=snsapi_userinfo&state=${uuid()}#wechat_redirect`
              },
              onCancel() {
                console.log('Cancel');
              },
              class: 'test',
            });
          }
        }
      })
    }
    if(res.code == 200 && location.pathname == '/'){
      location.href = '/wechat/home';
    }
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js